import { ChangeDetectorRef, OnDestroy, Pipe, PipeTransform, inject } from '@angular/core';
import { Subscription } from 'rxjs';
import { TranslationService } from '../services/translation.service';

// Traduce una clave (el texto en español) al idioma activo; si no existe, muestra la clave.
// Impuro para reaccionar al cambio de idioma, pero con una sola suscripción por instancia:
// antes se suscribía en cada ciclo de detección de cambios y nunca se desuscribía.
@Pipe({
    name: 'translate',
    standalone: true,
    pure: false,
})
export class TranslatePipe implements PipeTransform, OnDestroy {
    private readonly cdr = inject(ChangeDetectorRef);
    private translations: Record<string, string> = {};
    private readonly subscription: Subscription;

    constructor() {
        this.subscription = inject(TranslationService).getTranslations().subscribe((translations) => {
            this.translations = translations ?? {};
            this.cdr.markForCheck();
        });
    }

    transform(value: string | null | undefined): string {
        if (value === null || value === undefined) {
            return '';
        }
        return this.translations[value] ?? value;
    }

    ngOnDestroy(): void {
        this.subscription.unsubscribe();
    }
}
